import { render, staticRenderFns } from "./ProgramTemplateIndex.vue?vue&type=template&id=f122cb4e&scoped=true&"
import script from "./ProgramTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./ProgramTemplateIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTemplateIndex.vue?vue&type=style&index=0&id=f122cb4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122cb4e",
  null
  
)

export default component.exports